var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-canvas-edit-icon-button",on:{"click":_vm.editIcon}},[_vm._v("Change Icon")])
}
var staticRenderFns = []

export { render, staticRenderFns }